import React from 'react';
const benefits = [{
  icon: '📚',
  title: '6 Årlige Bind',
  desc: 'Måned-for-måned læringsmoduler, der dækker fra U10 til Junior.',
  color: 'from-blue-500/20 to-blue-600/5',
  borderColor: 'border-blue-500/20'
}, {
  icon: '📋',
  title: 'Pro Taktik-kit (PDF)',
  desc: 'Digitale plancher og HD-systemer til at vise på tablet/mobil, så dine spillere forstår det med det samme.',
  color: 'from-green-500/20 to-green-600/5',
  borderColor: 'border-green-500/20'
}, {
  icon: '🧤',
  title: 'Målmands-specialisering',
  desc: 'Færdig guide til træning af målmanden – banens mest oversete position.',
  color: 'from-purple-500/20 to-purple-600/5',
  borderColor: 'border-purple-500/20'
}, {
  icon: '🔄',
  title: '"Flow" Planlægning',
  desc: 'Kunsten bag overgange (angreb-forsvar) for dynamisk træning uden ventetid.',
  color: 'from-secondary/20 to-secondary/5',
  borderColor: 'border-secondary/20'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-14" data-id="element-3">
          <span className="inline-block text-primary font-bold text-sm tracking-widest uppercase mb-3" data-id="element-4">
            🎁 Hvad er der indeni?
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-5">
            Alt hvad du har brug for i{' '}
            <span className="text-primary" data-id="element-6">ét kit.</span>
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-7">
            Fire søjler af teknisk indhold designet til at eliminere stress.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8" data-id="element-8">
          {benefits.map((benefit, i) => <div key={i} className="bg-bg-alt p-8 rounded-3xl border border-border-light shadow-xl flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300 relative overflow-hidden group" data-id="element-9">
              <div className={`absolute inset-0 bg-gradient-to-br ${benefit.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} data-id="element-10"></div>

              <div className={`w-14 h-14 rounded-2xl bg-bg-dark border ${benefit.borderColor} flex items-center justify-center text-3xl mb-2 relative z-10 shadow-inner`} data-id="element-11">
                {benefit.icon}
              </div>
              <h3 className="text-2xl font-bold text-text-main relative z-10" data-id="element-12">
                {benefit.title}
              </h3>
              <p className="text-text-sec leading-relaxed text-lg relative z-10" data-id="element-13">
                {benefit.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}